import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  CarouselDirection,
  CarouselItemProps,
  CarouselProps,
  CarouselSnap,
} from './types';

const snapClasses: Record<CarouselSnap, string> = {
  start: '',
  center: 'carousel-center',
  end: 'carousel-end',
};

const directionClasses: Record<CarouselDirection, string> = {
  horizontal: '',
  vertical: 'carousel-vertical',
};

const CarouselBase = forwardRef<HTMLDivElement, CarouselProps>(
  (
    {
      className,
      snap = 'start',
      direction = 'horizontal',
      children,
      ...props
    },
    ref,
  ) => {
    const classes = twMerge(
      'carousel',
      snapClasses[snap],
      directionClasses[direction],
      className,
    );

    return (
      <div ref={ref} className={classes} {...props}>
        {children}
      </div>
    );
  },
);

const Item = forwardRef<HTMLDivElement, CarouselItemProps>(
  ({ className, children, ...props }, ref) => (
    <div ref={ref} className={twMerge('carousel-item', className)} {...props}>
      {children}
    </div>
  ),
);

CarouselBase.displayName = 'Carousel';
Item.displayName = 'Carousel.Item';

export const Carousel = Object.assign(CarouselBase, {
  Item,
});
